export const mbcDashboardModule = 'mbcDashboard';

export enum ViewByTabs {
  Youth = 'youth',
  Class = 'class',
  MeritBadge = 'meritBadge',
}
